/**
 * Swiper画像スライダーの各種設定を初期化する
 */
$(function(){
	//SP教室TOP、KB教室TOP、brandLP1・2、detailLP1・2画像
	let jsTopImageSwiperSp = '.js-top-image-swiper-sp';
	if ($(jsTopImageSwiperSp).find('.swiper-slide').length > 0 ) {
		const topImageSwiper = new Swiper(jsTopImageSwiperSp, {
			navigation: {
				nextEl: '.js-top-image-swiper-sp-button-next',
				prevEl: '.js-top-image-swiper-sp-button-prev',
			},
			loop: true,
			slidesPerView: 'auto',
			loopedSlides: $(jsTopImageSwiperSp).attr('data-photo-count')*3,
			centeredSlides : true,
			slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
			slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
			on: {
				/**
				 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
				 */
				slideChangeTransitionEnd: function () {
					var currentEl = document.getElementsByClassName('swiper-slide-active')[0];
					if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
						topImageSwiper.slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
					}
				}
			}
		});
	}

	//SP有料教室TOP、KB教室TOP画像
	let jsBrandKoushaTopImageSwiperSp = '.js-brand-kousha-top-image-swiper-sp';
	if ($(jsBrandKoushaTopImageSwiperSp).find('.swiper-slide').length > 0 ) {
		const koushaTopImageSwiper = new Swiper(jsBrandKoushaTopImageSwiperSp, {
			pagination: {
				el: ".js-brand-kousha-top-image-swiper-sp-pagenation",
				type: "fraction"
			},
			navigation: {
				nextEl: ".js-brand-kousha-top-image-swiper-sp-button-next",
				prevEl: ".js-brand-kousha-top-image-swiper-sp-button-prev"
			}
		});
	}

	//SPbrandLP1・2、detailLP1・2画像
	let jsBrandKoushaLpTopImageSwiperSp = '.js-brand-kousha-lp-top-image-swiper-sp';
	if ($(jsBrandKoushaLpTopImageSwiperSp).find('.swiper-slide').length > 0 ) {
		const brandKoushaLpTopImageSwiper = new Swiper(jsBrandKoushaLpTopImageSwiperSp, {
			pagination: {
				el: ".js-brand-kousha-lp-top-image-swiper-sp-pagenation",
				type: "fraction"
			},
			navigation: {
				nextEl: ".js-brand-kousha-lp-top-image-swiper-sp-button-next",
				prevEl: ".js-brand-kousha-lp-top-image-swiper-sp-button-prev"
			}
		});
	}

	//PC有料教室TOP、brandLP1・2、detailLP1・2画像
	let jsBrandKoushaTopImageSwiperPc = '.js-brand-kousha-top-image-swiper-pc';
	if ($(jsBrandKoushaTopImageSwiperPc).find('.swiper-slide').length > 0 ) {
		const brandKoushaTopImageSwiperPc = new Swiper(jsBrandKoushaTopImageSwiperPc, {
			loop: true, // ループ
			speed: 300, // 少しゆっくり(デフォルトは300)
			slidesPerView: 1.5, // 一度に表示する枚数
			loopAdditionalSlides: 2, // ループ時に表示させておくスライド数(指定なしだとループの切れ目で画像が欠ける)
			spaceBetween: 30, // スライド間の距離
			centeredSlides: true, // アクティブなスライドを中央にする
			// 前後の矢印
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}

	//PC有料教室・有料ブランドLP・1社請求LP(教室絞り込み) 中段の小さい教室画像　※N2を含む
	let jsBrandKoushaSmallImageSwiperPc = '.js-brand-kousha-small-image-swiper-pc';
	if ($(jsBrandKoushaSmallImageSwiperPc).find('.swiper-slide').length > 0 ) {
		const brandKoushaSmallImageSwiperPc = new Swiper(jsBrandKoushaSmallImageSwiperPc, {
			loop: true, // ループ
			slidesPerView: 3, // 一度に表示する枚数
			loopAdditionalSlides: 2, // ループ時に表示させておくスライド数(指定なしだとループの切れ目で画像が欠ける)
			spaceBetween: 30, // スライド間の距離
			// 前後の矢印
			navigation: {
				nextEl: '.js-swiper-button-next',
				prevEl: '.js-swiper-button-prev',
			},
			slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
			slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
			on: {
				/**
				 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
				 */
				slideChangeTransitionEnd: function () {
					var currentEl = document.getElementsByClassName('swiper-slide-active')[0];
					if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
						brandKoushaSmallImageSwiperPc.slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
					}
				}
			}
		});
	}

	//SPブランドオンライン・教室オンラインタブ
	let jsOnlineImageSwiperSp = '.js-online-image-swiper-sp';
	if ($(jsOnlineImageSwiperSp).find('.swiper-slide').length > 0 ) {
		const onlineImageSwiper = new Swiper(jsOnlineImageSwiperSp, {
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			loop: true,
			slidesPerView: 'auto',
			loopedSlides: $(jsOnlineImageSwiperSp).attr('data-photo-count')*3,
			centeredSlides : true,
			slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
			slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
			on: {
				/**
				 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
				 */
				slideChangeTransitionEnd: function () {
					var currentEl = document.getElementsByClassName('swiper-slide-active')[0];
					if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
						onlineImageSwiper.slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
					}
				}
			}
		});
	}

	// SP スマイルゼミ特別対応ページ用のスワイパー
	let jsTopImageSmileZemiSwiperSp = '.js-top-image-smile-zemi-swiper-sp';
	if ($(jsTopImageSmileZemiSwiperSp).find('.swiper-slide').length > 0 ) {
		const topImageSmileZemiSwiper = new Swiper(jsTopImageSmileZemiSwiperSp, {
			pagination: {
				el: ".js-top-image-smile-zemi-swiper-sp-pagination"
			},
			navigation: {
				nextEl: '.js-top-image-smile-zemi-swiper-sp-button-next',
				prevEl: '.js-top-image-smile-zemi-swiper-sp-button-prev',
			},
			loop: true,
			slidesPerView: 'auto',
			centeredSlides : true,
			slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
			slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
			on: {
				/**
				 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
				 */
				slideChangeTransitionEnd: function () {
					var currentEl = document.getElementsByClassName('swiper-slide-active')[0];
					if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
						topImageSmileZemiSwiper.slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
					}
				}
			}
		});
	}

	// SP Z会特別対応ページ用のスワイパー
	if($('.js-image-zkai-swiper-sp-container').length > 0){
		let imageZkaiSwiperSp = [];
		/**
		 * 各Z会スワイパーコンテナに対して個別の設定を適用する
		 */
		$('.js-image-zkai-swiper-sp-container').each(function (index) {
			// ユニークなクラス名を付与
			$(this).find('.js-image-zkai-swiper-sp').addClass('js-image-zkai-swiper-sp' + index);
			$(this).find('.js-image-zkai-swiper-sp-pagination').addClass('js-image-zkai-swiper-sp-pagination' + index);
			$(this).find('.js-image-zkai-swiper-sp-button-next').addClass('js-image-zkai-swiper-sp-button-next' + index);
			$(this).find('.js-image-zkai-swiper-sp-button-prev').addClass('js-image-zkai-swiper-sp-button-prev' + index);

			// スワイパーの設定
			let jsImageZkaiSwiperSp = '.js-image-zkai-swiper-sp' + index;
			if($(jsImageZkaiSwiperSp).find('.swiper-slide').length>0){
				imageZkaiSwiperSp[index] = new Swiper(jsImageZkaiSwiperSp, {
					pagination: {
						el: ".js-image-zkai-swiper-sp-pagination" + index
					},
					navigation: {
						nextEl: '.js-image-zkai-swiper-sp-button-next' + index,
						prevEl: '.js-image-zkai-swiper-sp-button-prev' + index,
					},
					loop: true,
					slidesPerView: 'auto',
					centeredSlides : true,
					slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
					slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
					on: {
						/**
						 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
						 */
						slideChangeTransitionEnd: function () {
							var currentEl = document.getElementsByClassName('swiper-slide-active')[index];
							if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
								imageZkaiSwiperSp[index].slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
							}
						}
					}
				});
			}
		})
	}

	// SP Z会特別対応ページ用のスワイパー
	if($('.js-image-zkai-swiper-pc-container').length > 0){
		let imageZkaiSwiperSp = [];
		/**
		 * 各Z会PC用スワイパーコンテナに対して個別の設定を適用する
		 */
		$('.js-image-zkai-swiper-pc-container').each(function (index) {
			// ユニークなクラス名を付与
			$(this).find('.js-image-zkai-swiper-pc').addClass('js-image-zkai-swiper-pc' + index);
			$(this).find('.js-image-zkai-swiper-pc-pagination').addClass('js-image-zkai-swiper-pc-pagination' + index);
			$(this).find('.js-image-zkai-swiper-pc-button-next').addClass('js-image-zkai-swiper-pc-button-next' + index);
			$(this).find('.js-image-zkai-swiper-pc-button-prev').addClass('js-image-zkai-swiper-pc-button-prev' + index);

			// スワイパーの設定
			let jsImageZkaiSwiperPc = '.js-image-zkai-swiper-pc' + index;
			if($(jsImageZkaiSwiperPc).find('.swiper-slide').length>0){
				imageZkaiSwiperSp[index] = new Swiper(jsImageZkaiSwiperPc, {
					pagination: {
						el: ".js-image-zkai-swiper-pc-pagination" + index
					},
					navigation: {
						nextEl: '.js-image-zkai-swiper-pc-button-next' + index,
						prevEl: '.js-image-zkai-swiper-pc-button-prev' + index,
					},
					loop: true,
					slidesPerView: 'auto',
					centeredSlides : true,
					slideDuplicateNextClass: 'swiper-custom-slide-duplicate-next',
					slideDuplicatePrevClass: 'swiper-custom-slide-duplicate-prev',
					on: {
						/**
						 * スライド切り替え完了時に複製スライドの場合は実スライドへジャンプする
						 */
						slideChangeTransitionEnd: function () {
							var currentEl = document.getElementsByClassName('swiper-slide-active')[index];
							if (currentEl !== undefined && currentEl.className.indexOf('swiper-slide-duplicate') != -1) {
								imageZkaiSwiperSp[index].slideToLoop(parseInt(currentEl.getAttribute('data-swiper-slide-index')), 0);
							}
						}
					}
				});
			}
		})
	}
});